import React, {Component} from 'react';
import Radium from 'radium';
import marked from 'marked';
import MapComponent from '../components/MapComponent';
import Colors from '../utils/colors';
import contentfulData from '../../contentfuldata/data.json';
import Breakpoints from '../utils/breakpoints'
import FullPageBlueItem from '../components/FullPageBlueItem';
import {prettifyUrl, getLang} from '../utils/util-functions';
import {getAZVetUrl} from '../utils/arkenzoo-vet-urls'
import _ from 'lodash';

export class VettrisArticle extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      linkString: props.path,
      activeLink: props.activeLink
    };
    this.changeToClinic = this.changeToClinic.bind(this);
  }

  changeToClinic(clinic){
    const azVetUrl = getAZVetUrl(clinic)
    if (azVetUrl) {
      window.location = azVetUrl
    } else {
      this.props.history.push('/'+clinic);
    }
  }

  render() {
    const brand = getLang();
    const mapTitle = contentfulData.singleData[brand].singleData.frontpageMapTitle;
    const mapItems = contentfulData.clinicsData[brand].clinicsData;
    const text = this.props.article.aboutText || "";
    const type = this.props.article.menu ? this.props.article.menu.fields.type : "";
    const sideBarHeadline = this.props.article.aboutSidebar ? this.props.article.aboutSidebar.fields.blueboxArticleHeadline : "";
    const sideBarText = this.props.article.aboutSidebar ? this.props.article.aboutSidebar.fields.blueboxArticleText : "";
    const reviewBoxTitle = this.props.article.aboutReview ? this.props.article.aboutReview.fields.blueboxReviewTitle : "";
    const reviewBoxName = this.props.article.aboutReview ? this.props.article.aboutReview.fields.blueboxReviewName : "";
    const reviewBoxText = this.props.article.aboutReview ? this.props.article.aboutReview.fields.blueboxReviewText : "";
    const reviewBoxImage = (this.props.article.aboutReview && this.props.article.aboutReview.fields.blueboxReviewImage) ? this.props.article.aboutReview.fields.blueboxReviewImage.fields.file.url : "";
    const clinicOpenText = contentfulData.singleData[brand].singleData.clinicOpenTitle;
    const clinicBookingText = contentfulData.singleData[brand].singleData.clinicBookingText;
    const noRecruitmentText = contentfulData.singleData[brand].singleData.noRecruitmentText;

    const Media = () => {
      return (
        <div>
          <div className="col-xs-12 col-md-7">
            <div dangerouslySetInnerHTML={ {__html: marked(text)} }></div>
          </div>
          <div className="col-xs-12 col-md-4 col-md-offset-1">
              {sideBarText !== "" &&
                <div style={styles.sideBar} className="extraSidebar">
                  <h3>{sideBarHeadline}</h3>
                  <div dangerouslySetInnerHTML={ {__html: marked(sideBarText)} }></div>
                </div>
              }
            <div className="hidden-xs"> <MapComponent items={mapItems} title={mapTitle} history={this.props.history}/></div>
          </div>
        </div> )
    };

    const About = () => {
      return (
          <div>
            <div className="col-xs-12 col-md-7 sideBar">
              <div dangerouslySetInnerHTML={ {__html: marked(text)} }></div>
              { reviewBoxTitle !== "" &&
                <div style={styles.reviewBox} className="reviewBox">
                  <div className="col-xs-12 col-sm-4">
                    <img className="img-circle" src={reviewBoxImage} />
                  </div>
                  <div className="col-xs-12 col-sm-8">
                    <h3>{reviewBoxName}</h3>
                    <h4>{reviewBoxTitle}</h4>
                    <p>{reviewBoxText}</p>
                  </div>
                  <div className="clearfix"></div>
                </div>
              }
            </div>
            <div className="col-xs-12 col-md-4 col-md-offset-1 sideBar">
              {sideBarText !== "" &&
                <div style={styles.sideBar} className="extraSidebar">
                  <h3>{sideBarHeadline}</h3>
                  <div dangerouslySetInnerHTML={ {__html: marked(sideBarText)} }></div>
                </div>
              }
              <div className="hidden-xs"> <MapComponent items={mapItems} title={mapTitle} history={this.props.history}/></div>
            </div>
          </div> )
    };

    const Contact = () => {
      return (
          <div>
            <div className="col-xs-12" style={styles.mobileBlueboxes}>
              {_.sortBy(mapItems, sorted => sorted.name).map((item, i) =>
                  <FullPageBlueItem key={i} name={item.name} extraText={clinicOpenText} buttonLink={item.bookingUrl}
                                    buttonText={clinicBookingText + " " + item.name} location={item.coordinates}
                                    phoneText={item.phoneText} phone={item.phone} clickExtraText={this.changeToClinic} history={this.props.history}/>
              )}
              <div style={styles.responsiveDivider} ></div>
              <div dangerouslySetInnerHTML={ {__html: marked(text)} }></div>
            </div>
          </div> )
    };

    const Employee = () => {
      return (
          <div>
            <div className="col-xs-12 col-md-7">
              <div dangerouslySetInnerHTML={ {__html: marked(text)} }></div>
              {_.sortBy(mapItems, it => it.recruitmentText).map((clinic, i) =>
                  <div key={i}>
                    { clinic.recruitmentText &&
                      <div style={styles.recruitmentActive}>
                        <h3>{clinic.name}</h3>
                        <p key={i}>{clinic.recruitmentText}</p>
                      </div>
                    }
                    { !clinic.recruitmentText &&
                    <div style={styles.recruitmentInactive}>
                      <h3>{clinic.name}</h3>
                      <p key={i}>{noRecruitmentText.replace("__EMAIL__", clinic.recruitmentEmail || "")}</p>
                    </div>
                    }
                  </div>
              )}
            </div>
            <div className="col-xs-12 col-md-4 col-md-offset-1">
              {sideBarText !== "" &&
                <div style={styles.sideBar} className="extraSidebar">
                  <h3>{sideBarHeadline}</h3>
                  <div dangerouslySetInnerHTML={ {__html: marked(sideBarText)} }></div>
                </div>
              }
              <div className="hidden-xs"> <MapComponent items={mapItems} title={mapTitle} history={this.props.history}/></div>
            </div>
          </div> )
    };

    //Hard coded for now.
    const types = {
      "media": <Media/>,
      "about": <About/>,
      "contact": <Contact />,
      "franchisee": <About/>,
      "employee": <Employee/>,
    };

    return (
        <div style={styles.main} className="row articles">
          {types[type]}
        </div>
    );
  }
}

export default Radium(VettrisArticle);

const styles = {
  main: {

  },
  sideBar: {
    backgroundColor: Colors.darkBlue,
    borderRadius: Breakpoints.borderRadius,
    padding: 30,
    color: '#ffffff',
    marginBottom: Breakpoints.componentDivider,
    marginTop: Breakpoints.componentDivider,
    [Breakpoints.media.siteUnderPadWidth]: {
      marginBottom: Breakpoints.mobileDivider
    },
  },
  mobileBlueboxes: {
    [Breakpoints.media.siteUnderPadWidth]: {
      marginLeft: -30,
      marginRight: -30
    },
  },
  reviewBox: {
    backgroundColor: Colors.darkBlue,
    padding: 30,
    color: '#ffffff',
    borderRadius: Breakpoints.borderRadius
  },
  responsiveDivider: {
    marginTop: Breakpoints.componentDivider,
    [Breakpoints.media.siteUnderPadWidth]: {
      marginTop: Breakpoints.mobileDivider
    }
  },
  recruitmentActive: {
    color: Colors.darkBlue
  },
  recruitmentInactive: {
    color: Colors.lightBrown
  },

};


// WEBPACK FOOTER //
// ./src/components/VettrisArticle.js